import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Account from '../views/Account.vue'
import Faq from '../views/Faq.vue'
import Blog from '../views/Blog.vue'
import Article from '../views/Article.vue'
import Page from '../views/Page.vue'
import VpnForStadia from '../views/VpnForStadia.vue'
import VpnForXCloud from '../views/VpnForXCloud.vue'
import VpnForGeForceNow from '../views/VpnForGeForceNow.vue'
import Extension from '../views/Extension.vue'
import ExtensionSetupVPN from '../views/extension/SetupVPN.vue'
import ExtensionPopup from '../views/extension/popup.vue'
import ExtensionPopup_old from '../views/ExtensionPopup.vue'
import FeatureToggle from '../views/FeatureToggle.vue'
import DNS from '../views/DNS.vue'
import DNSSetupVPN from '../views/dns/SetupVPN.vue'

import AppPaymentForm from '../views/AppPaymentForm.vue'
import AffiliateDashboard from '../views/AffiliateDashboard.vue'
import Reports from '../views/Reports.vue'
import SuppportedPlatforms from '../views/SupportedPlatforms.vue'
import TalkingAboutUs from '../views/TalkingAboutUs.vue'
import {loadLanguageAsync} from '../i18n'

Vue.use(VueRouter)

  const routes = [
    {
      path: '/extension-popup',
      name: 'Extension popup',
      component: ExtensionPopup_old
    },
    {
      path: '/app-paymentForm',
      name: 'App payment form',
      component: AppPaymentForm
    },
    
    {
      path: '/extension',
      name: 'Extension',
      component: Extension,
      children: [
        {
          path: 'setup-vpn',
          name: 'SetupVPN',
          component: ExtensionSetupVPN
        },
          {
              path: 'popup',
              name: 'Popup',
              component: ExtensionPopup
          }]
    },
    {
      path: '/dns',
      name: 'DNS',
      component: DNS,
      children: [
        {
          path: 'setup-vpn',
          name: 'SetupVPNDNS',
          component: DNSSetupVPN
        }]
    },
    {
      path: '/:locale',
      redirect: '/home',
      name: 'Page',
      component: Page,
      children: [
          {
        path: '',
        name: 'Home',
        component: Home
      },
        {
          path: 'vpn-for-stadia',
          name: 'Home_stadia',
          component: VpnForStadia
        },
        {
          path: 'vpn-for-xcloud',
          name: 'Home_xcloud',
          component: VpnForXCloud
        },
        {
          path: 'vpn-for-geforce-now',
          name: 'Home_GeForce',
          component: VpnForGeForceNow
        },
        {
          path: 'affiliate-dashboard',
          name: 'Affiliate dashboard',
          component: AffiliateDashboard,
          children: [  ]
        },
        {
          path: 'reports',
          name: 'Reports',
          component: Reports,
          children: [  ]
        },
        {
          path: 'supported-platforms',
          name: 'supported-platforms',
          component: SuppportedPlatforms,
          children: [  ]
      },
        {
          path: 'talking-about-us',
          name: 'talking-about-us',
          component: TalkingAboutUs,
          children: [  ]
      },
        {
          path: 'account',
          name: 'Account',
          component: Account
        },
        {
          path: 'faq',
          name: 'Frequently asked questions',
          component: Faq
        },
        {
          path: 'blog',
          name: 'Blog',
          component: Blog,
          children: [  ]
        },
        {
          path: 'article/:articleId',
          name: 'Article',
          component: Article,
          children: [  ],
          props: true
        },
        {
              path: 'feature-toggle',
              name: 'Feature toggle page',
              component: FeatureToggle
          }]
    }
    ,
    { // <---------------
      path: '*',
      redirect() {
        return process.env.VUE_APP_I18N_LOCALE;
      }
    }
]


//let locale = window.location.pathname.replace(/^\/([^/]+).*/i,'$1');
//base: (locale.trim().length && locale != "/") ? '/' + locale : undefined,
const router = new VueRouter({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  //Routing for root domain
  
  var urlPath = undefined;
  if (window.location.host.toLowerCase() === 'www.gameenable.com'){
	urlPath = location.href.split('gameenable.com/')[1];
	location.replace('https://gameenable.com/' + urlPath);
	return;
  } else if (window.location.host.toLowerCase().indexOf('gamingvpn.io') > -1){
	urlPath = location.href.split('gamingvpn.io/')[1];
	location.replace('https://gameenable.com/' + urlPath);
	return;
  }

  if(localStorage.preferedLocale && to.params.locale !== localStorage.preferedLocale){

      to.params.locale = localStorage.preferedLocale;
      router.push(to);

  }else{
      const locale = to.params.locale;

      Vue.vuetify.preset.rtl = ["iw","ar"].indexOf(locale) > -1
      loadLanguageAsync(locale).then(() => next());

  }

})

Vue.router = router;

export default router
